import { Component } from "./Component.js";

export class SystemStateComponent extends Component {}

SystemStateComponent.isSystemStateComponent = true;
